import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { InductionValidationResult } from 'src/app/models/induction-validation-result.model';
import { SiteInductionStatus } from 'src/app/shared/enums';
import { LocalizationService } from '../internationalization/localization.service';

const ERROR_CODE_LOCALIZATION_MAP: Record<string, string> = {
  'USER_1041': 'site_induction_confirmation_error_invalid_id',
  'USER_1042': 'site_induction_confirmation_error_name_mismatch',
  'USER_1043': 'site_induction_confirmation_error_no_config',
  'USER_1044': 'site_induction_confirmation_error_missing_params',
  'USER_1045': 'site_induction_confirmation_error_api_failure',
  'USER_1046': 'site_induction_confirmation_error_api_unavailable',
  'USER_1047': 'site_induction_confirmation_error_provider_not_configured',
};

@Component({
    selector: 'app-site-induction-confirmation',
    templateUrl: './site-induction-confirmation.component.html',
    styleUrls: ['./site-induction-confirmation.component.scss'],
    standalone: false
})
export class SiteInductionConfirmationComponent implements OnChanges {
  @Input() validationResult: InductionValidationResult | undefined;
  @Input() brandImageUrl: string | undefined;
  @Input() isEditMode: boolean = false;
  @Input() inductionIdInput: string = '';
  @Input() brandNameInput: string = '';

  @Output() continue = new EventEmitter<void>();
  @Output() resubmit = new EventEmitter<void>();

  title = '';
  successMessage = '';
  errorMessagePrefix = '';
  errorReason = '';

  constructor(
    private _localizationService: LocalizationService,
    private _datePipe: DatePipe
  ) {}

  ngOnChanges(): void {
    this.updateMessages();
  }

  get isSuccess(): boolean {
    return this.validationResult?.success === true;
  }

  onContinue(): void {
    this.continue.emit();
  }

  onResubmit(): void {
    this.resubmit.emit();
  }

  private updateMessages(): void {
    if (!this.validationResult) {
      return;
    }

    const partner = this.validationResult.siteInduction?.brandName ?? '';
    const enteredBrandName = this.brandNameInput ?? '';
    const apiInductionId = this.validationResult.siteInduction?.inductionId ?? '';
    const enteredInductionId = this.inductionIdInput ?? '';

    this.title = this._localizationService
      .translate(this.isEditMode ? 'site_induction_confirmation_title_update' : 'site_induction_confirmation_title')
      .replace('{partner}', partner);

    if (this.validationResult.success) {
      const status = this.validationResult.siteInduction?.status;
      if (status === SiteInductionStatus.NON_COMPLIANCE || !this.validationResult.siteInduction?.expiryDate) {
        this.successMessage = this._localizationService
          .translate(this.isEditMode ? 'site_induction_confirmation_success_message_non_compliance_update' : 'site_induction_confirmation_success_message_non_compliance')
          .replace('{partner}', partner)
          .replace('{inductionId}', apiInductionId);
      } else {
        const expiry = this._datePipe.transform(this.validationResult.siteInduction?.expiryDate, 'dd/MM/yyyy') ?? '';
        this.successMessage = this._localizationService
          .translate(this.isEditMode ? 'site_induction_confirmation_success_message_update' : 'site_induction_confirmation_success_message')
          .replace('{partner}', partner)
          .replace('{inductionId}', apiInductionId)
          .replace('{expiry}', expiry);
      }
      return;
    }

    this.errorMessagePrefix = this._localizationService
      .translate(this.isEditMode ? 'site_induction_confirmation_error_message_update' : 'site_induction_confirmation_error_message')
      .replace('{partner}', enteredBrandName || partner)
      .replace('{inductionId}', enteredInductionId);

    const errorCode = this.validationResult.errorCode ?? 'USER_1041';
    const localizationKey = ERROR_CODE_LOCALIZATION_MAP[errorCode] ?? 'site_induction_confirmation_error_invalid_id';
    this.errorReason = this._localizationService.translate(localizationKey);
  }
}